import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { communicationSettingFilters } from './communication-setting.filters';

// `validateSearch` de `/gestao-carteira/regua` (U07). Leve de propósito: é JS inicial.

/** Régua aberta no sheet (`novo` cria), na URL para o voltar fechar o sheet (U26). */
const edit = z.string().min(1).max(64).optional().catch(undefined);
/** Sheet dos filtros no iPhone (`?sheet=filtros`). */
const sheet = z.string().min(1).max(40).optional().catch(undefined);

/** Página (a partir de 1), tamanho, os filtros do legado e a régua em edição. */
export const communicationSettingSearch = listSearchSchema({ ...communicationSettingFilters.shape, edit, sheet });
export type CommunicationSettingSearch = z.infer<typeof communicationSettingSearch>;
